import { useFormContext } from "react-hook-form";
import { directiveEntryFormSteps } from "../constants/directiveEntryFormSteps.constant";
import { MaintenanceForwardingsDirectiveFromSteps } from "../types/maintenanceForwardingsShowDirectiveDetails.type";
import { useEffect, useState } from "react";

export const useCreateForwardingFormStepValidation = (
  step: MaintenanceForwardingsDirectiveFromSteps,
  dependencies: (string | number | boolean | null | undefined)[],
) => {
  const { getValues } = useFormContext();

  const [isValid, setIsValid] = useState(false);

  const isStepValid = async (): Promise<boolean> => {
    const schemaForStep = directiveEntryFormSteps[step]?.schema;

    if (!schemaForStep) return false;

    const values = getValues();
    const result = await schemaForStep.safeParseAsync(values);

    return result.success;
  };

  useEffect(() => {
    isStepValid().then(setIsValid);
  }, dependencies);

  return { isValid };
};
